// export const API_URL = "http://localhost:8000";
// export const API_URL = "http://development.mega.dev.cuco.lu";
export const API_URL = "https://mega.prod.cuco.lu";
export const translations = {
    loadingQuestions: {
        de: "Lade Fragen...",
        fr: "Chargement des questions...",
        lb: "Lued Froen..."
    },
    question: {
        de: "Frage",
        fr: "Question",
        lb: "Fro"
    },
    filter: {
        de: "Filtern Sie die Karte nach festgelegten Kriterien.",
        fr: "Trier la carte suivant des critères définis.",
        lb: "Sortéiert d'Kaart no definéierte Critèren."
    },
    voting: {
        label: {
            de: "Wahlsystem",
            fr: "Système Électoral",
            lb: "Walsystem"
        },
        relative: {
            de: "relative Mehrheitswahl",
            fr: "majorité relative",
            lb: "Majorz-Gemeng"
        },
        proportional: {
            de: "Verhältniswahl",
            fr: "représentation proportionnelle",
            lb: "Proporz-Gemeng"
        }
    },
    answer: {
        de: "Antwort",
        fr: "Réponse",
        lb: "Äntwert"
    },
    additionalInfo: {
        de: "Zusatzinformationen",
        fr: "Informations complémentaires",
        lb: "Weider Informatioun"
    },
    csv: {
        de: "Im EXCEL-Format herunterladen",
        fr: "Télécharger au format EXCEL",
        lb: "Eroflueden am EXCEL Format"
    },
    website: {
        de: "Link zur Gemeinde",
        fr: "Lien vers la commune",
        lb: "Link zu der Gemeng"
    },
    yes: {
        de: "Ja",
        fr: "Oui",
        lb: "Oui"
    },
    no: {
        de: "Nein",
        fr: "Non",
        lb: "Non"
    },
    accordionMore: {
        de: "Mehr Informationen",
        fr: "Plus d'information",
        lb: "Méi Informatioun"
    },
    accordionLess: {
        de: "Schließen",
        fr: "Fermer",
        lb: "Zoumaachen"
    },
    placeholderText: {
        de: "Klicken Sie mit Ihrer Maus auf die Karte, um die Ergebnisse der Region anzuzeigen.",
        fr: "Cliquez avec votre souris sur la carte pour voir les résultats de chaque commune.",
        lb: "Klickt mat der Maus op d'Kaart fir d'Resultater fir all Gemeng ze gesinn."
    },
    citizenNumber: {
        de: "Einwohneranzahl",
        fr: "Nombre d'habitants",
        lb: "Bevëlkerung"
    },
    legend: {
        results: {
            de: "Antwort",
            fr: "Réponse",
            lb: "Réponse"
        },
        relative: {
            de: "relative Mehrheitswahl",
            fr: "le système de la majorité relative",
            lb: "Majorz-Gemeng"
        },
        proportional: {
            de: "Verhältniswahl",
            fr: "scrutin de liste avec représentation proportionnelle",
            lb: "Proporz-Gemeng"
        },
    },
    reset: {
        de: "Zurücksetzen",
        fr: "Réinitialiser",
        lb: "Zerécksetzen"
    },
    print: {
        de: "Drucken",
        fr: "Imprimer",
        lb: "Drécken"
    },
    community: {
        de: "Gemeinde",
        fr: "Commune",
        lb: "Gemeng"
    }
};
